
export default function DesignConcept() {
  const floors = [
    {
      floor: '1층',
      title: '필로티 공개공지',
      description: '고급 라운지와 팝업존으로 구성된 개방형 공간',
      features: ['프리미엄 라운지', '팝업 스토어 존', '커뮤니티 공간']
    },
    {
      floor: '2층',
      title: '메인샵',
      description: '다양한 상업시설과 편의시설 집약',
      features: ['프리미엄 리테일', '카페 & 레스토랑', 'F&B 시설']
    },
    {
      floor: '3-4층',
      title: '스마트 공공시설',
      description: '주민 누구나 이용 가능한 첨단 시설',
      features: ['스마트 피트니스', '공유 오피스', '문화 공간']
    },
    {
      floor: '5-7층',
      title: '방문객 주차장',
      description: '강남3구 주차난 해소에 기여하는 대규모 주차시설',
      features: ['500대 이상 수용', '스마트 주차 시스템', '전기차 충전소']
    },
    {
      floor: '8층 이상',
      title: '프리미엄 레지던스',
      description: '스마트 홈 자동화가 적용된 하이엔드 오피스텔',
      features: ['스마트 홈 시스템', '옥상 정원', '프리미엄 뷰']
    }
  ];

  return (
    <section id="design" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">설계 컨셉 & 건축</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            현대적 디자인과 기능성을 완벽하게 조화시킨 층별 구성으로<br />
            최적의 공간 활용과 편의성을 실현합니다.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start mb-20">
          <div className="relative h-[600px] rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://public.readdy.ai/ai/img_res/851f04c559c3e520675b21b135028ffa.jpg" 
              alt="건물 단면도" 
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="space-y-6">
            {floors.map((floor, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all cursor-pointer">
                <div className="flex items-start">
                  <div className="w-16 h-16 bg-teal-600 rounded-lg flex items-center justify-center mr-5 flex-shrink-0">
                    <span className="text-white font-bold text-lg">{floor.floor}</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{floor.title}</h3>
                    <p className="text-gray-600 mb-4">{floor.description}</p>
                    <div className="flex flex-wrap gap-2">
                      {floor.features.map((feature, idx) => (
                        <span key={idx} className="bg-teal-50 text-teal-700 px-3 py-1 rounded-full text-sm font-medium">
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-2xl p-10 shadow-lg">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">건축 디자인 특징</h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-pencil-ruler-2-line text-4xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">현대적 외관</h4>
              <p className="text-gray-600">
                세련된 유리 파사드와 기하학적 디자인으로 서초동의 새로운 랜드마크 창출
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-plant-line text-4xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">조경 통합</h4>
              <p className="text-gray-600">
                각 필지별 조경을 유기적으로 연계하여 자연친화적 환경 조성
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-flash-line text-4xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">스마트 통합</h4>
              <p className="text-gray-600">
                건물 전체에 IoT 기술을 적용한 지능형 빌딩 관리 시스템
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
